/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($, _c, undefined) {
  'use strict';

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.

  function faqPageFunction() {
    jQuery('#faqs .faqs .q').on('click', function(e) {
      e.preventDefault();
      if (jQuery(this).hasClass('active')) {
        jQuery(this).removeClass('active');
        jQuery(this)
          .next()
          .slideUp();
      } else {
        jQuery(this).addClass('active');
        jQuery(this)
          .next()
          .slideDown();
      }
    });

    jQuery('#faq-filter').keyup(function(e) {
      var s = jQuery(this).val();
      if (s == '') {
        jQuery('.faqs .item').show();
        jQuery('.faqs .item').removeClass('showeverything');
      } else {
        jQuery('.faqs .item').hide();
        jQuery(".faqs .item:icontains('" + s + "')").show();
        jQuery(".faqs .item:icontains('" + s + "')")
          .addClass('showeverything')
          .show();
      }
    });

    jQuery('#faq-filter-submit').click(function(e) {
      e.preventDefault();
      var s = jQuery('#faq-filter').val();
      if (s == '') {
        jQuery('.faqs .item').show();
        jQuery('.faqs .item').removeClass('showeverything');
      } else {
        jQuery('.faqs .item').hide();
        jQuery(".faqs .item:icontains('" + s + "')").show();
        jQuery(".faqs .item:icontains('" + s + "')")
          .addClass('showeverything')
          .show();
      }
    });

    var fixedElementOffset = jQuery('.fixed-element').offset().top - 80;
    var footerOffset = jQuery('#footer').offset().top - 80;
    var fixedElementHeight = jQuery('.fixed-element').height();
    var sidebarHeight = jQuery('.sidebar .cnt').height();
    var contentHeight = jQuery('.check-height').height();

    jQuery(window).scroll(function(event) {
      if (sidebarHeight < contentHeight) {
        var y = jQuery(this).scrollTop();
        var line_left = jQuery('.sidebar').offset().left;
        line_left = line_left + 8;
        jQuery('.sidebar .cnt').css('left', line_left);

        if (y >= fixedElementOffset && y + fixedElementHeight < footerOffset) {
          jQuery('.fixed-element').addClass('fixed');
          jQuery('.fixed-element').removeClass('bottom');
        } else if (
          y >= fixedElementOffset &&
          y + fixedElementHeight >= footerOffset
        ) {
          jQuery('.fixed-element').removeClass('fixed');
          jQuery('.fixed-element').addClass('bottom');
        } else {
          jQuery('.fixed-element').removeClass('fixed bottom');
        }
      }
    });

    jQuery(window).resize(function() {
      var line_left = jQuery('.sidebar').offset().left;
      line_left = line_left + 8;
      jQuery('.sidebar .cnt').css('left', line_left);
    });
  }

  var Sage = {
    // All pages
    common: {
      init: function() {
        // JavaScript to be fired on all pages

        $(window).load(function() {
          $('#banner h1').addClass('on');
          $('#banner p').addClass('on');
          $('#banner .btn').addClass('on');
        });

        $('.disable-link>a').on('click', function(event) {
          event.preventDefault();
        });

        $('.animsition').animsition({
          inClass: 'fade-in',
          outClass: 'fade-out-up-sm',
          inDuration: 800,
          outDuration: 800,
          linkElement: '.animsition-link',
          loading: true,
          loadingParentElement: 'body',
          loadingClass: 'animsition-loading',
          loadingInner: '',
          timeout: false,
          timeoutCountdown: 5000,
          onLoadEvent: true,
          browser: ['animation-duration', '-webkit-animation-duration'],
          overlay: false,
          overlayClass: 'animsition-overlay-slide',
          overlayParentElement: 'body',
          transition: function(url) {
            window.location.href = url;
          },
        });

        $('.hamburger').on('click', function() {
          $(this).toggleClass('is-active');
          if ($(this).hasClass('is-active')) {
            $('.mobile-menu').fadeIn(500);
          } else {
            $('.mobile-menu').fadeOut(500);
          }
        });

        $('.mobile-menu .parent > a').on('click', function(e) {
          e.preventDefault();
          if (
            $(this)
              .parent()
              .hasClass('open')
          ) {
            $(this)
              .parent()
              .removeClass('open');
            $(this)
              .next()
              .slideUp(300);
          } else {
            $(this)
              .parent()
              .addClass('open');
            $(this)
              .next()
              .slideDown(300);
          }
        });

        $('.disable').on('click', function(e) {
          e.preventDefault();
        });

        $('#alert .close').on('click', function(evt) {
          evt.preventDefault();
          $('body').removeClass('alert');
          $(this)
            .parent('#alert')
            .hide();

          $.ajax({
            url: window.cbs_ajax.ajax_url,
            data: {
              action: 'hide_alert',
            },
            type: 'POST',
            success: function() {
              return;
            },
          });
        });

        // Scroll To
        (function() {
          $('.scrollto').on('click', function(e) {
            e.preventDefault();
            var section = $(this).attr('href');
            $('html, body').animate(
              {
                scrollTop: $(section).offset().top,
              },
              1000
            );
          });
        })();

        // Megamenu
        (function() {
          $('.open-mega').on('click', function(e) {
            e.preventDefault();
            $('.megamenu').fadeIn(300);
            $('html, body').animate(
              {
                scrollTop: $('.header').offset().top,
              },
              1000
            );
          });
          $('.megamenu .close').on('click', function(e) {
            e.preventDefault();
            $('.megamenu').fadeOut(300);
          });
        })();

        // Search
        // (function() {
        // 	$('#search').mouseenter(function(){
        // 		$('#search input[type="text"]').addClass('open');
        // 		$('#search input[type="text"]').focus();
        // 	}).mouseleave(function(){
        // 		$('#search input[type="text"]').removeClass('open');
        // 		$('#search input[type="text"]').blur();
        // 	});
        // })();

        // Back to Top
        (function() {
          $('.back-top').on('click', function(e) {
            e.preventDefault();
            $('html, body').animate(
              {
                scrollTop: $('.header').offset().top,
              },
              1000
            );
          });
          if ($('#process').length >= 1) {
            var waypoint_top = new Waypoint({
              element: document.getElementById('process'),
              handler: function(direction) {
                if (direction === 'down') {
                  $('.back-top').addClass('on');
                }
                if (direction === 'up') {
                  $('.back-top').removeClass('on');
                }
              },
              offset: '0%',
            });
          }
        })();
        forHotFixes();
        $.extend($.expr[':'], {
          icontains: function(elem, i, match, array) {
            return (
              (elem.textContent || elem.innerText || '')
                .toLowerCase()
                .indexOf((match[3] || '').toLowerCase()) >= 0
            );
          },
        });

        if ($('.gform_confirmation_wrapper ').length) {
          $('html, body').animate(
            {
              scrollTop: $('.gform_confirmation_wrapper ').offset().top - 100,
            },
            1000
          );
        }
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },

    // Home page
    page_template_template_home: {
      init: function() {
        $(window).load(function() {
          $('#hero h1').addClass('on');
        });

        var waypoint1 = new Waypoint({
          element: document.getElementById('ctas'),
          handler: function(direction) {
            if (direction === 'down') {
              $('.cta-box-large').addClass('on');
            }
          },
          offset: '77%',
        });

        if ($('#small-ctas').length) {
          var waypoint2 = new Waypoint({
            element: document.getElementById('small-ctas'),
            handler: function(direction) {
              if (direction === 'down') {
                $('.cta-box').addClass('on');
              }
            },
            offset: '77%',
          });
        }

        // Handle the case when we don't have important dates
        var datesEl = document.getElementById('dates');
        if (datesEl !== null) {
          var waypoint3 = new Waypoint({
            element: datesEl,
            handler: function(direction) {
              if (direction === 'down') {
                $('.date-box').addClass('on');
              }
            },
            offset: '77%',
          });
        }

        if ($('#featured-news').length) {
          var waypoint4 = new Waypoint({
            element: document.getElementById('featured-news'),
            handler: function(direction) {
              if (direction === 'down') {
                $('#featured-news .featured').addClass('on');
                $('#featured-news .post').addClass('on');
              }
            },
            offset: '77%',
          });
        }

        if ($('#featured').length) {
          var waypoint5 = new Waypoint({
            element: document.getElementById('featured'),
            handler: function(direction) {
              if (direction === 'down') {
                $('#featured h2').addClass('on');
                $('#featured p').addClass('on');
                $('#featured a').addClass('on');
              }
            },
            offset: '77%',
          });
        }

        //date classes
        var datesNumber = $('#dates .col-xs-4').length;
        console.log(datesNumber);
        if (datesNumber === 1) {
          $('#dates .row').addClass('one-box');
        }
        if (datesNumber === 2) {
          $('#dates .row').addClass('two-box');
        }
        if (datesNumber === 3) {
          $('#dates .row').addClass('three-box');
        }
        if (datesNumber === 4) {
          $('#dates .row').addClass('four-box');
        }
        if (datesNumber === 5) {
          $('#dates .row').addClass('five-box');
        }
        if (datesNumber === 6) {
          $('#dates .row').addClass('six-box');
        }
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    // News page
    page_template_template_news: {
      init: function() {
        $('#news .post').each(function(e) {
          var post = $(this);
          var post_waypoint = new Waypoint({
            element: post[0],
            handler: function(direction) {
              if (direction === 'down') {
                post.addClass('on');
              }
            },
            offset: '77%',
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    // Blogs page
    blog: {
      init: function() {
        $('#news .post').each(function(e) {
          var post = $(this);
          var post_waypoint = new Waypoint({
            element: post[0],
            handler: function(direction) {
              if (direction === 'down') {
                post.addClass('on');
              }
            },
            offset: '77%',
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    // FAQ page
    page_template_template_faq: {
      init: faqPageFunction,
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    page_template_template_faq_2: {
      init: faqPageFunction,
      finalize: function() {},
    },

    // Board Members page
    page_template_template_board_members: {
      init: function() {
        $('#members .member-box').each(function(e) {
          var post = $(this);
          var post_waypoint = new Waypoint({
            element: post[0],
            handler: function(direction) {
              if (direction === 'down') {
                post.addClass('on');
              }
            },
            offset: '77%',
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    // OCC Overview page
    page_template_template_occ_overview: {
      init: function() {
        $('.timeline-row').each(function(e) {
          var post = $(this);
          var post_waypoint = new Waypoint({
            element: post[0],
            handler: function(direction) {
              if (direction === 'down') {
                post.addClass('on');
              }
            },
            offset: '77%',
          });
        });

        var fixedElementOffset = $('.fixed-element').offset().top - 80;
        var footerOffset = $('#footer').offset().top - 80;
        var fixedElementHeight = $('.fixed-element').height();
        var sidebarHeight = $('.sidebar .cnt').height();
        var contentHeight = $('.check-height').height();

        $(window).scroll(function(event) {
          if (sidebarHeight < contentHeight) {
            var y = $(this).scrollTop();
            var line_left = $('.sidebar').offset().left;
            line_left = line_left + 8;
            $('.sidebar .cnt').css('left', line_left);

            if (
              y >= fixedElementOffset &&
              y + fixedElementHeight < footerOffset
            ) {
              $('.fixed-element').addClass('fixed');
              $('.fixed-element').removeClass('bottom');
            } else if (
              y >= fixedElementOffset &&
              y + fixedElementHeight >= footerOffset
            ) {
              $('.fixed-element').removeClass('fixed');
              $('.fixed-element').addClass('bottom');
            } else {
              $('.fixed-element').removeClass('fixed bottom');
            }
          }
        });

        $(window).resize(function() {
          var line_left = $('.sidebar').offset().left;
          line_left = line_left + 8;
          $('.sidebar .cnt').css('left', line_left);
        });
      },
    },

    // OCC Overview page
    page_template_template_occ_component: {
      init: function() {
        $('.timeline-row').each(function(e) {
          var post = $(this);
          var post_waypoint = new Waypoint({
            element: post[0],
            handler: function(direction) {
              if (direction === 'down') {
                post.addClass('on');
              }
            },
            offset: '77%',
          });
        });

        var fixedElementOffset = $('.fixed-element').offset().top - 80;
        var footerOffset = $('#footer').offset().top - 80;
        var fixedElementHeight = $('.fixed-element').height();
        var sidebarHeight = $('.sidebar .cnt').height();
        var contentHeight = $('.check-height').height();

        $(window).scroll(function(event) {
          if (sidebarHeight < contentHeight) {
            var y = $(this).scrollTop();
            var line_left = $('.sidebar').offset().left;
            line_left = line_left + 8;
            $('.sidebar .cnt').css('left', line_left);

            if (
              y >= fixedElementOffset &&
              y + fixedElementHeight < footerOffset
            ) {
              $('.fixed-element').addClass('fixed');
              $('.fixed-element').removeClass('bottom');
            } else if (
              y >= fixedElementOffset &&
              y + fixedElementHeight >= footerOffset
            ) {
              $('.fixed-element').removeClass('fixed');
              $('.fixed-element').addClass('bottom');
            } else {
              $('.fixed-element').removeClass('fixed bottom');
            }
          }
        });

        $(window).resize(function() {
          var line_left = $('.sidebar').offset().left;
          line_left = line_left + 8;
          $('.sidebar .cnt').css('left', line_left);
        });
      },
    },

    // Process page
    page_template_template_specialty_certification_process: {
      init: function() {
        $('.timeline-row').each(function(e) {
          var post = $(this);
          var post_waypoint = new Waypoint({
            element: post[0],
            handler: function(direction) {
              if (direction === 'down') {
                post.addClass('on');
              }
            },
            offset: '77%',
          });
        });

        var fixedElementOffset = $('.fixed-element').offset().top - 80;
        var footerOffset = $('#footer').offset().top - 80;
        var fixedElementHeight = $('.fixed-element').height();
        var sidebarHeight = $('.sidebar .cnt').height();
        var contentHeight = $('.check-height').height();

        $(window).scroll(function(event) {
          if (sidebarHeight < contentHeight) {
            var y = $(this).scrollTop();
            var line_left = $('.sidebar').offset().left;
            line_left = line_left + 8;
            $('.sidebar .cnt').css('left', line_left);

            if (
              y >= fixedElementOffset &&
              y + fixedElementHeight < footerOffset
            ) {
              $('.fixed-element').addClass('fixed');
              $('.fixed-element').removeClass('bottom');
            } else if (
              y >= fixedElementOffset &&
              y + fixedElementHeight >= footerOffset
            ) {
              $('.fixed-element').removeClass('fixed');
              $('.fixed-element').addClass('bottom');
            } else {
              $('.fixed-element').removeClass('fixed bottom');
            }
          }
        });

        $(window).resize(function() {
          var line_left = $('.sidebar').offset().left;
          line_left = line_left + 8;
          $('.sidebar .cnt').css('left', line_left);
        });

        $('#process .sidebar h2 a').on('click', function(event) {
          event.preventDefault();
          if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $('#process .sidebar .process-nav').slideUp(300);
          } else {
            $(this).addClass('open');
            $('#process .sidebar .process-nav').slideDown(300);
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    // Process Inside page
    page_template_template_specialty_written_exams: {
      init: function() {
        var fixedElementOffset = $('.fixed-element').offset().top - 80;
        var footerOffset = $('#footer').offset().top - 80;
        var fixedElementHeight = $('.fixed-element').height();
        var sidebarHeight = $('.sidebar .cnt').height();
        var contentHeight = $('.check-height').height();

        $(window).scroll(function(event) {
          if (sidebarHeight < contentHeight) {
            var y = $(this).scrollTop();
            var line_left = $('.sidebar').offset().left;
            line_left = line_left + 8;
            $('.sidebar .cnt').css('left', line_left);

            if (
              y >= fixedElementOffset &&
              y + fixedElementHeight < footerOffset
            ) {
              $('.fixed-element').addClass('fixed');
              $('.fixed-element').removeClass('bottom');
            } else if (
              y >= fixedElementOffset &&
              y + fixedElementHeight >= footerOffset
            ) {
              $('.fixed-element').removeClass('fixed');
              $('.fixed-element').addClass('bottom');
            } else {
              $('.fixed-element').removeClass('fixed bottom');
            }
          }
        });

        $(window).resize(function() {
          var line_left = $('.sidebar').offset().left;
          line_left = line_left + 8;
          $('.sidebar .cnt').css('left', line_left);
        });

        $('#process .sidebar h2 a').on('click', function(event) {
          event.preventDefault();
          if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $('#process .sidebar .process-nav').slideUp(300);
          } else {
            $(this).addClass('open');
            $('#process .sidebar .process-nav').slideDown(300);
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },

    // Contact page
    page_template_template_contact: {
      init: function() {
        //initialize();
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        console.log('okfuncname', funcname);
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(window.jQuery, window.Clique); // Fully reference jQuery after this point.

function resizeIFrameToFitContent(iFrame) {
  iFrame.width = iFrame.contentWindow.document.body.scrollWidth;
  iFrame.height = iFrame.contentWindow.document.body.scrollHeight;
}

window.addEventListener('DOMContentReady', function(e) {
  var iFrame = document.getElementById('integrationIframe');
  resizeIFrameToFitContent(iFrame);

  // or, to resize all iframes:
  var iframes = document.querySelectorAll('iframe');
  for (var i = 0; i < iframes.length; i++) {
    resizeIFrameToFitContent(iframes[i]);
  }
});
